import img1 from "./WhatsApp Image 2025-11-27 at 1.20.03 PM.jpeg";

export default [
  img1,
];
